import ConfirmModal, { ConfirmModalProps } from './ConfirmModal';

const ConfirmLeaveModal: React.FC<ConfirmModalProps> = (props) => {
  return (
    <ConfirmModal
      {...props}
      width='clamp(480px, 90vw, 575px)'
    />
  );
};

export default ConfirmLeaveModal;
